import React, { useEffect } from "react";
import { useNavigate,Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import Swal from "sweetalert2";
import { authApi } from "../../../repositories/auth";
import { handleError } from "../../../utils/errorHandler";

interface LabelCode {
  code: string;
}

const ValidateSchema = Yup.object({
  code: Yup.string().required("Code is required"),
});

const LabelCodePage: React.FC = () => {
  const navigate = useNavigate();

  const initialValues: LabelCode = {
    code: "",
  };

  const handleSubmit = async (
    values: LabelCode,
    { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
  ) => {
    try {
      const { data } = await authApi.validateCode(values.code);
      if (data?.valid) {
        Swal.fire({
          title: "Congratulations!",
          text: "You've been granted, Your code is valid.",
          icon: "success",
          confirmButtonText: "Continue",
        });
        navigate('/auth/signup');
        
      }

    } catch (error) {
      console.error("Error validating code:", error);
      handleError(error);
    } finally {
      setSubmitting(false);
    }
  };

    useEffect(() => {
      const authData = localStorage.getItem("auth");
      if (authData) {
        const auth = JSON.parse(authData);
        if (auth.token) {
          navigate("/dashboard");
        }
      }
    });

  return (
    <div className="flex items-center justify-center min-h-screen px-4 py-12 bg-gray-50 sm:px-6 lg:px-8">
      <div className="w-full max-w-md p-8 space-y-8 bg-white shadow-lg rounded-xl">
        <div>
          <h1 className="text-3xl font-bold text-center text-gray-900">
          Welcome to Cadencel
          </h1>
          <p className="mt-4 text-lg text-center">Please enter your label verification code to continue</p>
        </div>
        
        <Formik
          initialValues={initialValues}
          validationSchema={ValidateSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="mt-8 space-y-6">
              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="labelCode"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Label Code
                  </label>
                  <Field
                    id="labelCode"
                    name="code"
                    type="text"
                    className="block w-full px-4 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-md"
                  />
                  <ErrorMessage
                    name="code"
                    component="div"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                >
                  {isSubmitting ? "Verifying Code..." : "Verify Code"}
                </button>
                <div>
                  <p className="mt-2 text-sm text-center text-gray-600">
                    Already have an account?{" "}
                    <Link
                      to="/auth/login"
                      className="font-medium text-indigo-600 hover:text-indigo-500"
                    >
                      Log in
                    </Link>
                  </p>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LabelCodePage;
